// src/utils/audioUploader.js
import axios from 'axios';

export const getAudioResult = async (originalReadPresignedUrl, audio1_filename) => {
  const getTheResultUrl = 'https://z5hkab3qbxyfm5kzkmaglfwz5i0lfgux.lambda-url.ap-south-1.on.aws/';
  const requestData = {
    audio_url_1: originalReadPresignedUrl,
    audio1_filename: audio1_filename,   
};
    try {
    const response = await axios.post(getTheResultUrl, requestData, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Failed to get the results:', error);
    return false;
  }
};